export default class VideoModalCarousel {
    static instances = null;

		static create(container) {
			if (VideoModalCarousel.instances === null) {
				if (container) {
					const videoModal = document.querySelector('#video-modal-carousel');
					const playButtons = container.querySelectorAll('.play-btn-carousel');

					VideoModalCarousel.instances = [];

					if (playButtons.length && videoModal) {
						playButtons.forEach(playBtn => {
							VideoModalCarousel.instances.push(new VideoModalCarousel(playBtn, videoModal));
						});
					}
				}
			}
		}

		static destroy() {
			if (VideoModalCarousel.instances) {
				VideoModalCarousel.instances.forEach(instance => {
					instance.beforeDestroy();
				});
				VideoModalCarousel.instances = null;
			}
		}

	constructor(playBtn, videoModal) {
		this.playBtn = playBtn;
		this.videoModal = videoModal;
		this.closeBtn = this.videoModal.querySelector('.modal-close-btn');
		this.iframe = this.videoModal.querySelector('iframe');
		this.modalContent = this.videoModal.querySelector('.modal-content');
		this.body = document.body;

		this.playClick = this.playClick.bind(this);
		this.closeClick = this.closeClick.bind(this);
		this.documentClick = this.documentClick.bind(this);

		this.init();
	}

	init() {
        this.playBtn.addEventListener('click', this.playClick);
		if (this.closeBtn) {
            this.closeBtn.addEventListener('click', this.closeClick);
		}
		document.addEventListener('click', this.documentClick);
	}

    playClick(e) {
        const vimeoUrl = this.playBtn.getAttribute('data-vimeo');
        if (vimeoUrl) {
			const autoplayUrl = `${vimeoUrl}?autoplay=1&muted=1`;
            this.iframe.src = autoplayUrl;
            this.modalContent.appendChild(this.iframe);
            setTimeout(() => {
                this.body.classList.add('modal-active');
            }, 100);
            this.videoModal.style.display = 'flex';
        }
    }

	closeClick() {
		this.hideModal();
	}

	documentClick(e) {
		if ((this.body.classList.contains('modal-active')) && (!e.target.closest('iframe'))) {
			this.hideModal();
		}
	}

	hideModal() {
		this.body.classList.remove('modal-active');
		this.videoModal.style.display = 'none';
		if (this.iframe) {
			this.iframe.remove();
		}
	}

	beforeDestroy() {
		this.playBtn.removeEventListener('click', this.playClick);
		if (this.closeBtn) {
			this.closeBtn.removeEventListener('click', this.closeClick);
		}
		document.removeEventListener('click', this.documentClick);
	}
}
